import { render, staticRenderFns } from "./ServiceEntitlementCards.vue?vue&type=template&id=72c645bd&"
import script from "./ServiceEntitlementCards.vue?vue&type=script&lang=js&"
export * from "./ServiceEntitlementCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports